module.exports = __webpack_public_path__ + "static/specification-technique-3-c9f2a7f57da45dd92a18eb199cc74282.pdf";